import { useDispatch, useSelector } from "react-redux";

import {Typography} from "@material-ui/core";
import React, {useEffect} from "react";
import Grid from "@material-ui/core/Grid";
import FiltersSection from "../../Filters/FiltersSection";
import {makeStyles} from "@material-ui/core/styles";
// import {
//     getOSEEstatisticasPorOperador,
//     getServiceOrderDetail,
//     getServiceOrderProcessDetail, getServiceOrderServiceDetail,
// } from "../../../actions/orderActions";
// import connect from "react-redux/lib/connect/connect";
// import {addServiceOrders} from "../../../actions/serviceOrderStatistics";
// import {addAutoclaveCicloOrdemServico} from "../../../actions/autoclaveActions";

import {getOSEEstatisticasPorOperador} from "../../../actions/orderActions"
import OperadoresDistributionOnEtapasHourStackedChart from "./OperadoresDistributionOnEtapasHourStackedChart";
import Card from "../../../common/Card";
import Paper from "@material-ui/core/Paper";

//TODO: Desenvolver cards por eficiencia de Operador

const useStyles = makeStyles(theme => ({
    dashboardSection: {
        // padding: "5px"
    },
    sectionTitle: {
        marginBottom: theme.spacing(1) * 4,
        marginTop: theme.spacing(1) * 4
    },
    marginTop: {
        marginTop: theme.spacing(1) * 4
    },
    marginBottom: {
        marginBottom: theme.spacing(1) * 5,
    },
    marginBottomCharts: {
        margin: theme.spacing(1) * 3,
    },
    marginRight: {
        paddingRight: theme.spacing(1) * 2
    },
    progress: {
        margin: theme.spacing(1) * 2,
    },
}));

const Operadores = ({

                    }) => {
    const classes = useStyles();

    const st = useSelector(state => state);
    console.log("REDUX STATE", st)
    const estatisticaOperadorPorHoraDia = useSelector(state => state.ordemServicoReducer.estatisticaOperadorPorHoraDia);
    const periodMin = useSelector(state => state.filter.periodMin);
    const periodMax = useSelector(state => state.filter.periodMax);
    const loading = useSelector(state => state.ordemServicoReducer.isFetchingEstatisticasOperadores)

    const dispatch = useDispatch();

    useEffect( () => {
        console.log("useEffect 0,0 getOSEEstatisticasPorOperador");
        dispatch(getOSEEstatisticasPorOperador());
    }, []);

    // useEffect(() => {
    //     dispatch(getOSEEstatisticasPorOperador());
    // }, [periodMin]);
    //
    // useEffect(() => {
    //     dispatch(getOSEEstatisticasPorOperador());
    // }, [periodMax]);


    const onFilterClick = () => {
        dispatch(getOSEEstatisticasPorOperador());
    }

    console.log("estatisticaOperadorPorHoraDia", estatisticaOperadorPorHoraDia);

    let operadores  = []
    estatisticaOperadorPorHoraDia.map( (eo => {
        let x = operadores.findIndex( o => o.operadorId === eo.operadorId);
        if (x < 0) { operadores.push({ operadorId: eo.operadorId, nome: eo.Operador})}
    }))

    console.log("operadores", operadores);



    return (
        <React.Fragment>
            <Grid container direction="column" className={classes.dashboardSection}>
                <Grid item xs={12}>
                    <FiltersSection showPeriod={true} showBeforePeriod={false} showBenchPeriod={false}  onFilterClick={onFilterClick} loading={loading} />
                </Grid>
            </Grid>
            <Grid item  xs={12} sm={12} lg={12} xl={12}>
                <Typography variant="h4" align="center" className={classes.sectionTitle}>
                    OPERADORES
                </Typography>
            </Grid>
            <Grid item  xs={12} sm={12} lg={12} xl={12}>

                {operadores.map( (o,ix) => {

                    const s1 = estatisticaOperadorPorHoraDia.filter( eo => eo.operadorId === o.operadorId );
                    return (
                            <Paper style={{marginTop: '10px'}}>
                                <OperadoresDistributionOnEtapasHourStackedChart series={s1}  key={ix} operador={s1[0].Operador} />
                            </Paper>
                        );

                            })}

            </Grid>
        </React.Fragment>
    )

}

// const mapStateToProps = state => {
//     return {
//         isAuthenticated: state.auth.id !== null,
//
//     }
// }
//
// export default connect(mapStateToProps, {
//     getOSEEstatisticasPorOperador
// })(Operadores)
//

export default Operadores;
